/*
src/ui-panels/SunPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {FormGroup, Slider} from '@blueprintjs/core';

import {ColorPicker} from '../ui-misc/ColorPicker.js';
import {ImagesList} from '../ui-misc/ImagesList.js';


export class SunPanel extends React.Component {


	constructor(props) {
		super(props);

		// Params are specific properties of the ParamsManager that use the getParams and setParams methods.
		// The paramsOfInterest object is used to fetch only the params used by this panel.
		// The propertiesOfInterest array includes the names of all params of interest, plus any additional
		//	properties of interest that are not params. It is used to determine if the panel needs to be re-rendered.
		// Examples: width is a param, but sunImage is not. Both are properties.
		this._paramsOfInterest = {sunPosition: null, sunSize: null, sunNoImageColor: null};
		this._propertiesOfInterest = ['sunImage'];
		for (const key in this._paramsOfInterest) {
			this._propertiesOfInterest.push(key);
		}

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSetParams = this.handleSetParams.bind(this);
		this.handleSelectImage = this.handleSelectImage.bind(this);
		
		this._paramsMan = this.props.workspace.getParamsManager();
		this._sunImageBank = this.props.workspace.getSunImageBank();

		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);
		this._sunImageBank.registerCallback('change', this.forceRender);

		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {
		// Re-render only if any of the properties of interest have changed.
		for (const key of this._propertiesOfInterest) {
			if (data.newValues.hasOwnProperty(key)) {
				this.forceRender();
				return;
			}
		}
	}

	handleSetParams(p) {
		this._paramsMan.setParams(p);
	}

	handleSelectImage(image) {
		this._paramsMan.setSunImage(image);
	}


	render() {
	
		let params = this._paramsMan.getParams(this._paramsOfInterest);

		return (
			<div style={{maxWidth: "750px", margin: "30px auto"}}>

				<ColorPicker label="Sun No-Image Color" color={params.sunNoImageColor} allowAlpha={false}
					onChange={value => this.handleSetParams({sunNoImageColor: value})} />

				<FormGroup label="Sun Position" labelFor="sun-position-slider">
					<Slider id="sun-position-slider" min={0.0} max={1.0} stepSize={0.001} labelStepSize={0.1}
						onChange={value => this.handleSetParams({sunPosition: value})} value={params.sunPosition} />
				</FormGroup>

				<FormGroup label="Sun Size" labelFor="sun-size-slider">
					<Slider id="sun-size-slider" min={0.01} max={0.1} stepSize={0.001} labelStepSize={0.02}
						onChange={value => this.handleSetParams({sunSize: value})} value={params.sunSize} />
				</FormGroup>
		
				<ImagesList bank={this._sunImageBank}
					onSelect={this.handleSelectImage}
					selected={this._paramsMan.getSunImage()}
				/>
			
			</div>
		);
	}

}


